import { homePreviewPath } from '@/assets/js/product';
import account from './modules/account';
import activity from './modules/activity';
import shopping from './modules/shopping';
import staticModule from './modules/static';
import themePage from './modules/themePage';

export default {
  routes: (_routes) => [
    {
      name: 'index',
      path: '/',
      component: () => import('@/views/index/HomePage.vue').then((r) => r.default || r),
      meta: {
        keepalive: true,
        cnName: '首页',
        feature_value_name: 'home_recommend',
      },
    },
    {
      name: 'indexPreview',
      path: homePreviewPath, // 首页预览模式
      component: () => import('@/views/index/HomePage.vue').then((r) => r.default || r),
    },
    ...shopping,
    ...staticModule,
    ...activity,
    ...account,
    ...themePage,
  ],
};
